<template>
  <div class="container">
    <sp-tabs v-model="active_index" :tabs="tabs">
      <template #default="{ tabs }">
        <wxgame-playable-page-path-list :key="active_index" v-bind="tabs[active_index].componentProps" />
      </template>
    </sp-tabs>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'sp-tabs': () => import('@/components/sp-tabs'),
    'wxgame-playable-page-path-list': () => import('./components/wxgame-playable-page-path-list/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active_index: 0,
    };
  },
  computed: {
    tabs() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code, delivery_content_id } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(advertiser => {
        return {
          label: advertiser.label,
          componentProps: {
            formItem: this.formItem,
            advertiserId: advertiser.advertiser_id,
            deliveryContentId: delivery_content_id.value.split('#')[0],
          },
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 500px;
}
</style>
